import type { ClassificationTuple, Readiness } from './staging'

/** Short uppercase marker for the file's detected binary type (e.g. PNG, SVG). */
export function detectedTypeLabel(contentType: string): string {
	const subtype = contentType.split('/')[1] ?? contentType
	const cleaned = subtype.replace(/^x-|^vnd\..*[.+]/, '').replace(/[^a-z0-9]/gi, '')
	if (cleaned.includes('svg')) return 'SVG'
	if (cleaned.includes('jpeg') || cleaned.includes('jpg')) return 'JPG'
	return cleaned.slice(0, 4).toUpperCase() || 'FILE'
}

/** One staged file as the grid renders it. */
export interface ClassifyRowView {
	/**
	 * Client-side id. Nothing is uploaded until commit, so there is no server
	 * `fileId` to key on while these rows are being classified.
	 */
	stagedId: string
	fileName: string
	contentType: string
	/** Local object URL for an image, else null — the type marker stands in. */
	previewUrl?: string | null
	/** Resolved classification (batch merged with row overrides). */
	classification: ClassificationTuple
	readiness: Readiness
	/** This file's upload failed during a commit; the row stays for retry. */
	error?: string | null
}
